import { useState, useEffect, useRef } from "react";
import APIs from "./../APIs"; // Adjust path if needed
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserData } from "./../redux/authSlice";
import { toast } from "react-toastify";
import { Toast } from "bootstrap";
import { Link, useLocation } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import * as bootstrap from "bootstrap";


const Footer = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    full_name: "",
    mobile_number: "",
    user_type: "",
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastData, setToastData] = useState(null);
  const [otpSource, setOtpSource] = useState(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6-digit OTP

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputsRef = useRef([]);
  const [forgotEmail, setForgotEmail] = useState("");
  const [loadingForgot, setLoadingForgot] = useState(false);
  const [resetPassword, setResetPassword] = useState({ password: "", confirmPassword: "" });
  const [resetErrors, setResetErrors] = useState({});
  const [loadingReset, setLoadingReset] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });

  const [countryList, setCountryList] = useState([])
  const [loading4, setLoading4] = useState(false);
  const [selectedCode, setSelectedCode] = useState([])

  useEffect(() => {
    getCountryApi()
  }, [])

  useEffect(() => {
    if (countryList.length && !selectedCode) {
      setSelectedCode(countryList[0]);
    }
  }, [countryList]);


  const getCountryApi = async () => {
    setLoading4(true)
    try {
      const response = await APIs.post("user/getCountry", {});
      console.log("getCountryApi Response:", response.data.data[0]);

      if (response.data.status == "success") {
        setLoading4(false)
        setCountryList(response.data.data)
        setSelectedCode(response.data.data[0])
      } else {
        setLoading4(false)
        toast.error(response.data.message, { position: "top-right" });
      }
    } catch (error) {
      setLoading4(false)
      toast.error("Error getCountryApi", { position: "top-right" });
    } finally {
      setLoading4(false);
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      toast.error("Please enter your email address", { position: "top-right" });
      return;
    }
    setLoadingForgot(true);
    setMessage("");
    sessionStorage.setItem("pendingUser", JSON.stringify({ email: forgotEmail }));

    try {
      const response = await APIs.post("user/forgotPassword", { email: forgotEmail }, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        const userData = response.data.data;
        dispatch(setUserData(userData));
        sessionStorage.setItem("userData", JSON.stringify(userData));
        setOtpSource("forgot"); // ✅ important for back button
        setTimeout(() => {
          const loginEl = document.getElementById("ForgotPasswordModalToggle");
          if (loginEl) {
            const loginModal =
              window.bootstrap.Modal.getInstance(loginEl) ||
              new window.bootstrap.Modal(loginEl);
            loginModal.hide();
          }

          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "failed.", { position: "top-right" });
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed. Please try again.", { position: "top-right" });
    } finally {
      setLoadingForgot(false);
    }
  };
  const validateResetPassword = () => {
    const newErrors = {};
    if (!resetPassword.password) newErrors.password = "Password is required";
    else if (resetPassword.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    if (!resetPassword.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
    else if (resetPassword.password !== resetPassword.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    setResetErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetErrors(""); // optional top-level error

    if (!validateResetPassword()) return; // use per-field validation

    const storedUserData = JSON.parse(sessionStorage.getItem("userData"));
    const user_id = storedUserData?.user_id;
    if (!user_id) {
      setResetErrors("User not found.");
      return;
    }

    setLoadingReset(true);
    try {
      const response = await APIs.post("user/resetPassword", {
        user_id,
        password: resetPassword.password,
      });

      toast.success("Password reset successfully!", { position: "top-right" });

      const resetModalEl = document.getElementById("ResetPasswordModalToggle");
      const resetModal = window.bootstrap.Modal.getInstance(resetModalEl);
      resetModal.hide();

      const resetEl = document.getElementById("LoginModalToggle");
      if (resetEl) {
        const loginModal = new window.bootstrap.Modal(resetEl);
        loginModal.show();
      }
    } catch (error) {
      setResetErrors(error.response?.data?.message || "Failed to reset password");
    } finally {
      setLoadingReset(false);
    }
  };



  // ✅ Auto-clear messages after 5s
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  // ✅ Load login email/password only
  useEffect(() => {
    const savedData = sessionStorage.getItem("loginFormData");
    if (savedData) {
      const parsed = JSON.parse(savedData);
      setFormData((prev) => ({
        ...prev,
        email: parsed.email || "",
        password: parsed.password || "",
      }));
    }
  }, []);

  // ✅ Save login email/password only
  useEffect(() => {
    sessionStorage.setItem(
      "loginFormData",
      JSON.stringify({ email: formData.email, password: formData.password })
    );
  }, [formData.email, formData.password]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  // Validate signup form
  const validateSignup = () => {
    const newErrors = {};
    if (!formData.full_name) newErrors.full_name = "User Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }
    if (!formData.mobile_number)
      newErrors.mobile_number = "Mobile number is required";
    if (!formData.user_type) newErrors.user_type = "User Type is required";
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validate login form
  const validateLogin = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  // Login Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateLogin()) return;

    setLoading(true);
    setMessage("");

    try {
      const response = await APIs.post("user/loginViaOTP", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        const email = formData.email?.trim().toLowerCase();

        // ✅ Store only email temporarily until OTP verified
        sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

        setToastData({
          title: "Login",
          message: response.data.message,
          type: "success",
          id: Date.now(),
        });

        setOtpSource("login"); // ✅ important for back button
        setTimeout(() => {
          const loginEl = document.getElementById("LoginModalToggle");
          if (loginEl) {
            const loginModal =
              window.bootstrap.Modal.getInstance(loginEl) ||
              new window.bootstrap.Modal(loginEl);
            loginModal.hide();
          }

          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "Login failed.", { position: "top-right" });
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Login failed. Please try again.", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSuccess = async (tokenResponse) => {
    try {
      let email = "";
      let google_id = "";

      if (tokenResponse?.credential) {
        // From <GoogleLogin /> button
        const decoded = jwtDecode(tokenResponse.credential);
        email = decoded?.email || "";
        google_id = decoded?.sub || "";
      } else if (tokenResponse?.access_token) {
        // From useGoogleLogin() hook
        const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        }).then((res) => res.json());

        email = userInfo?.email || "";
        google_id = userInfo?.sub || "";
      }

      if (!email || !google_id) {
        toast.error("Google login failed. Missing required info.", {
          position: "top-right",
        });
        return;
      }

      // ✅ Always use FormData for same API
      const formData = new FormData();
      formData.append("email", email.trim().toLowerCase());
      formData.append("google_id", google_id);

      const response = await APIs.post("user/loginViaOTP", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

        setToastData({
          title: "Login",
          message: response.data.message,
          type: "success",
          id: Date.now(),
        });

        setOtpSource("login");
        setTimeout(() => {
          const loginEl = document.getElementById("LoginModalToggle");
          if (loginEl) {
            const loginModal =
              window.bootstrap.Modal.getInstance(loginEl) ||
              new window.bootstrap.Modal(loginEl);
            loginModal.hide();
          }

          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "Login failed.", {
          position: "top-right",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Google login error. Try again later.", {
        position: "top-right",
      });
    }
  };


  // Initialize the Google login hook
  const loginWithGoogle = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => toast.error("Google Login Failed", { position: "top-right" }),
  });

  // Signup Submit
  const handleSignup = async (e) => {
    e.preventDefault();
    if (!validateSignup()) return;

    setMessage("");

    try {
      const payload = new FormData();
      payload.append("full_name", formData.full_name);
      payload.append("email", formData.email);
      payload.append("mobile_number", formData.mobile_number);
      payload.append("user_type", formData.user_type);
      payload.append("password", formData.password);
      payload.append("user_register_type", "Normal");
      payload.append("country_id", selectedCode.country_id);
      payload.append("country_code", selectedCode.country_code);


      const response = await APIs.post("user/createUser", payload);
      const email = formData.email?.trim().toLowerCase();
      // ✅ Store only email temporarily
      sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

      setToastData({
        title: "Signup",
        message: response.data.message,
        type: "success",
        id: Date.now(),
      });

      setOtpSource("signup"); // ✅ important for back button
      setTimeout(() => {
        const signupEl = document.getElementById("signupModalToggle");
        if (signupEl) {
          const signupModal =
            window.bootstrap.Modal.getInstance(signupEl) ||
            new window.bootstrap.Modal(signupEl);
          signupModal.hide();
        }

        const otpEl = document.getElementById("OtpModalToggle");
        if (otpEl) {
          const otpModal = new window.bootstrap.Modal(otpEl);
          otpModal.show();
        }
      }, 1000);
    } catch (error) {
      toast.error(error.response?.data?.message || "Signup failed. Try again.", { position: "top-right" });
    }
  };

  // OTP Handlers
  const handleChangeOTP = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[idx] = val ? val[0] : "";
    setOtp(newOtp);
    if (val && idx < 5) {
      inputsRef.current[idx + 1].focus();
    }
  };

  const handleBackspace = (e, idx) => {
    if (e.key === "Backspace" && !otp[idx] && idx > 0) {
      inputsRef.current[idx - 1].focus();
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();

    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      toast.error("Enter 6-digit OTP", { position: "top-right" });
      return;
    }

    const pendingUser = JSON.parse(sessionStorage.getItem("pendingUser"));
    const email = pendingUser?.email;

    if (!email) {
      toast.error("User email not found. Please login again.", {
        position: "top-right",
      });
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await APIs.post("user/verifyOTP", { otp: otpValue, email });

      if (response.data.status === "success") {
        const verifiedUser = response.data.data;

        // ✅ Save verified user data
        dispatch(setUserData(verifiedUser));
        sessionStorage.setItem("userData", JSON.stringify(verifiedUser));
        sessionStorage.removeItem("pendingUser");

        toast.success("OTP verified successfully!", { position: "top-right" });

        setTimeout(() => {
          const otpModalEl = document.getElementById("OtpModalToggle");
          const otpModal = window.bootstrap.Modal.getInstance(otpModalEl);
          otpModal.hide();

          if (otpSource === "forgot") {
            const resetModalEl = document.getElementById("ResetPasswordModalToggle");
            const resetModal = new window.bootstrap.Modal(resetModalEl);
            resetModal.show();
          } else {
            window.location.href = "/Dashboard";
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "OTP verification failed", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };



  const handleBack = () => {
    const otpModal = document.getElementById("OtpModalToggle");
    if (otpModal) {
      const modal = window.bootstrap.Modal.getInstance(otpModal);
      modal.hide();
    }

    if (otpSource === "login") {
      const loginModal = document.getElementById("LoginModalToggle");
      if (loginModal) {
        const modal = new window.bootstrap.Modal(loginModal);
        modal.show();
      }
    }

    if (otpSource === "signup") {
      const signupModal = document.getElementById("signupModalToggle");
      if (signupModal) {
        const modal = new window.bootstrap.Modal(signupModal);
        modal.show();
      }
    }
    if (otpSource === "forgot") {
      const forgotModal = document.getElementById("ForgotPasswordModalToggle");
      if (forgotModal) {
        const modal = new window.bootstrap.Modal(forgotModal);
        modal.show();
      }
    }
  };
  const handleForgotBack = () => {
    const forgotModal = document.getElementById("ForgotPasswordModalToggle");
    if (forgotModal) {
      const modal = window.bootstrap.Modal.getInstance(forgotModal);
      modal.hide();
    }

    if (otpSource === "login") {
      const loginModal = document.getElementById("LoginModalToggle");
      if (loginModal) {
        const modal = new window.bootstrap.Modal(loginModal);
        modal.show();
      }
    }
  };

  const handleResendOTP = async () => {
    try {
      const savedData = JSON.parse(sessionStorage.getItem("loginFormData"));
      const email = savedData?.email;

      if (!email) {
        toast.error("Email not found. Please login again.", { position: "top-right" });
        return;
      }

      setLoading(true);
      setMessage("");

      const response = await APIs.post("user/resendOTP", { email });

      if (response.data.status === "success") {
        toast.success("OTP resent successfully!");
      } else {
        toast.error(response.data.message || "Failed to resend OTP.", { position: "top-right" });
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to resend OTP.", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };
  const handleCloseModal = (modalId) => {
    const modalEl = document.getElementById(modalId);
    const modalInstance =
      window.bootstrap.Modal.getInstance(modalEl) ||
      new window.bootstrap.Modal(modalEl);

    modalInstance.hide(); // properly hides the modal
    window.location.reload();
  };
  const [services, setServices] = useState([]);

  const getAllServices = async () => {

    try {
      const response = await APIs.get('service/getAllService', {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      console.log('Get Service Response -', response.data);

      if (response.data.status === "success") {
        setServices(response.data.data);
      }

    } catch (error) {
      if (error.response) {
        const { statusCode, message } = error.response.data;

        if (statusCode === 401) {
          setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
        } else if (statusCode === 422) {
          setToastData({ title: 'Service', message: message, type: 'info', id: Date.now() });
        } else if (statusCode === 409) {
          setToastData({ title: 'Service', message: message, type: 'warning', id: Date.now() });
        } else if (statusCode === 400 || statusCode === 404) {
          setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
        } else if (statusCode === 500) {
          setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
        }
      } else {
        setToastData({ title: 'Service', message: error.message, type: 'danger', id: Date.now() });
      }
    }
  }
  useEffect(() => {
    getAllServices();
  }, []);
  const location = useLocation();
  const path = location.pathname;

  let title = "";
  if (path === "/about-us") title = "About Us";
  else if (path === "/services") title = "Services";
  else if (path === "/contact") title = "Contact Us";
  else if (path === "/service-details") title = "Service Details";

  function initModalSwitcher() {
    const triggers = document.querySelectorAll('[data-bs-toggle="modal"][data-bs-dismiss="modal"]');

    triggers.forEach(trigger => {
      // Avoid duplicate listeners
      trigger.removeEventListener("click", handleModalSwitch);
      trigger.addEventListener("click", handleModalSwitch);
    });
  }

  /**
   * Handles switching between modals smoothly.
   */
  function handleModalSwitch(e) {
    e.preventDefault();
    const trigger = e.currentTarget;
    const targetModalSelector = trigger.getAttribute("data-bs-target");
    const currentModal = trigger.closest(".modal");
    const targetModal = document.querySelector(targetModalSelector);

    if (currentModal && targetModal) {
      const currentModalInstance = bootstrap.Modal.getInstance(currentModal);
      currentModalInstance.hide();

      currentModal.addEventListener("hidden.bs.modal", function onHidden() {
        const newModal = new bootstrap.Modal(targetModal);
        newModal.show();
        currentModal.removeEventListener("hidden.bs.modal", onHidden);
      });
    }
  }

  // ✅ Initialize once when DOM is ready
  document.addEventListener("DOMContentLoaded", initModalSwitcher);
  useEffect(() => {
    initModalSwitcher();
  }, []);

  return (
    <>
      {/* Your Footer UI and Modals remain same */}
      {/* footer */}
      <footer className="site-footer footer-style-2 eagle-bg-color-blackish">
        <div className="eagle-footer-widget-area">
          <div className="container">
            <div className="row">
              {/* Column 1 */}
              <div className="eagle-footer-widget-col-1 col-md-6 col-lg-3">
                <aside className="widget widget_text">
                  <div className="eagle-footer-logo">
                    <img src="images/logo.png" alt="Logo" />
                  </div>
                  <div className="eagle-footer-text">
                    <span className="eagle-footer-desc">
                      Discover our commitment to excellence in transport and
                      logistics.
                    </span>
                  </div>
                </aside>
                <aside className="widget widget-contact">
                  <div className="eagle-contact-widget-lines">
                    <div className="eagle-contact-widget-line">
                      <span>Customer Care</span>
                      <a href="tel:+19853778070"> +1 985 3778070</a>
                    </div>
                    <div className="eagle-contact-widget-line">
                      <span>Need live support?</span>
                      <a href="mailto:go@eagleobc.com">go@eagleobc.com</a>
                    </div>
                  </div>
                </aside>
              </div>

              {/* Column 2 */}
              <div className="eagle-footer-widget-col-2 col-md-6 col-lg-3">
                <aside className="widget widget_text">
                  <h2 className="widget-title">Services</h2>
                  <div className="textwidget">
                    <ul>
                      {services.map((service, index) => (
                        <li><a href="#">{service.service_name}</a></li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </div>

              {/* Column 3 */}
              <div className="eagle-footer-widget-col-3 col-md-6 col-lg-3">
                <aside className="widget widget_text">
                  <h2 className="widget-title">Useful Links</h2>
                  <div className="textwidget">
                    <ul>
                      <li><Link to="/about-us">About Us</Link></li>
                      <li><Link to="/services">Services</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                      <li><Link to="/privacy">Privacy Policy</Link></li>
                    </ul>
                  </div>
                </aside>
              </div>

              {/* Column 4 */}
              <div className="eagle-footer-widget-col-4 col-md-6 col-lg-3">
                <aside className="widget widget_text">
                  <h2 className="widget-title">Social Media</h2>
                  <div className="textwidget">
                    <ul className="eagle-social-links">
                      <li className="eagle-social-li eagle-social-facebook">
                        <a title="Facebook" href="https://www.facebook.com/profile.php?id=61579233387293" target="_blank" rel="noopener noreferrer">
                          <span><i className="eagle-base-icon-facebook-app-symbol"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-twitter">
                        <a title="Twitter" href="#" target="_blank" rel="noopener noreferrer">
                          <span><i className="eagle-base-icon-twitter-2"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-instagram">
                        <a title="Instagram" href="#" target="_blank" rel="noopener noreferrer">
                          <span><i className="eagle-base-icon-instagram"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-youtube">
                        <a title="YouTube" href="#" target="_blank" rel="noopener noreferrer">
                          <span><i className="eagle-base-icon-youtube-play"></i></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>

        <div className="eagle-footer-text-area">
          <div className="container">
            <div className="eagle-footer-text-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="eagle-footer-copyright-text-area">
                    Copyright © {new Date().getFullYear()}
                    <a href="#"> Eagle OBC</a>, All Rights Reserved.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer End */}
      { /* Modal */}

      {/* Signup Modal */}
      <div
        className="modal fade commen-popup"
        id="signupModalToggle"
        aria-hidden="true"
        aria-labelledby="signupModalToggleLabel2"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("signupModalToggle")}
                  ></button>

                  <div className="col-md-12 text-center">
                    {message && (
                      <div
                        className={`alert ${message.toLowerCase().includes("success")
                          ? "alert-success bg-success text-white"
                          : "alert-danger bg-danger text-white"
                          }`}
                        role="alert"
                      >
                        {message}
                      </div>
                    )}

                  </div>
                  <h5 className="modal-title">Sign Up</h5>
                  <p>
                    Welcome Back! Let&apos;s get started. Please sign in to access all the amazing services
                  </p>

                  {/* Signup Form */}
                  <form className="signup-form" onSubmit={handleSignup}>
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="User Name *"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                        />
                        {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </div>

                      <div className="col-sm-12 mb-6">
                        <div className="input-group d-flex gap-2">
                          <div className="flex-shrink-0">
                            {/* Country Code Dropdown */}
                            <select
                              value={selectedCode ? String(selectedCode.country_id) : ""}
                              onChange={(e) => {
                                const selectedId = Number(e.target.value);

                                const country = countryList.find(
                                  (c) => c.country_id === selectedId
                                );

                                setSelectedCode(country);
                                console.log("Selected country:", country);
                              }}
                              style={{
                                color: "black",
                                background: "white",
                                border: "1px solid #ced4da",    // small gray border
                                borderRadius: "4px",         // optional: slightly rounded corners
                                outline: "none",             // removes focus outline
                                boxShadow: "none",           // remove any shadow
                                padding: "2px 4px 0px 10px",          // compact padding
                                fontSize: "0.85rem",         // slightly smaller text
                                appearance: "none",          // remove default arrow styling in some browsers
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                                marginRight: "10px",
                              }}
                            >
                              {/* placeholder */}
                              <option value="" hidden>
                                Code
                              </option>

                              {countryList.map((c) => (
                                <option key={c.country_id} value={String(c.country_id)}>
                                  {c.country_name} {c.country_code}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="flex-grow-1">
                            {/* Mobile Number */}
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Your mobile number *"
                              name="mobile_number"
                              value={formData.mobile_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {errors.mobile_number && (
                          <small className="text-danger">{errors.mobile_number}</small>
                        )}
                      </div>


                      <div className="col-sm-12 mb-2">
                        <select
                          className="form-control select-control"
                          name="user_type"
                          value={formData.user_type}
                          onChange={handleChange}
                        >
                          <option value="">User Type</option>
                          <option value="Individual">Individual Customer</option>
                          <option value="Corporate">Corporate</option>
                        </select>
                        {errors.user_type && <small className="text-danger">{errors.user_type}</small>}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <input
                          // type="password"
                          type={showPassword.password ? "text" : "password"}
                          className="form-control"
                          placeholder="Your Password *"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                          className="position-absolute"
                          style={{
                            cursor: "pointer",
                            top: "74%",
                            right: "595px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              password: !showPassword.password,
                            })
                          }
                        >
                          <i
                            className={`${showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                          ></i>
                        </span>
                        {errors.password && <small className="text-danger">{errors.password}</small>}

                      </div>

                      <div className="col-md-12 mb-3">
                        <button type="submit" className="eagle-btn w-100 text-center">
                          <span className="eagle-button-text">Signup</span>
                          <span className="eagle-button-icon-wrapper">
                            <span className="eagle-button-icon">
                              <i className="eagle-base-icon-black-arrow-1"></i>
                            </span>
                          </span>
                        </button>
                      </div>



                      <div className="col-md-12 col-lg-12">
                        Already have an account?{" "}
                        <a
                          href="javascript:void(0)"
                          data-bs-target="#LoginModalToggle"
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                        >
                          Login Now!
                        </a>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="col-lg-6">
                  <img src="images/banner-slider-img/1.jpg" className="img-fluid" alt="Signup" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      { /* End */}
      {/* Model  */}
      {/* Login Modal */}
      <div
        className="modal fade commen-popup"
        id="LoginModalToggle"
        aria-hidden="true"
        aria-labelledby="LoginModalToggleLabel"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("LoginModalToggle")}
                  ></button>
                  {message && (
                    <div
                      className={`alert ${message.toLowerCase().includes("success")
                        ? "alert-success bg-success text-white"
                        : "alert-danger bg-danger text-white"
                        }`}
                      role="alert"
                    >
                      {message}
                    </div>
                  )}

                  <h5 className="modal-title" id="LoginModalToggleLabel">
                    Login
                  </h5>
                  <p>
                    Welcome Back! Let's get started. Please sign in to access all
                    the amazing services
                  </p>

                  <form
                    className="Login-form"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <small className="text-danger">{errors.email}</small>
                        )}
                      </div>

                      <div className="col-sm-12 mb-2 position-relative">
                        <input
                          type={showPassword.password ? "text" : "password"}
                          className="form-control"
                          placeholder="Password *"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        {errors.password && (
                          <small className="text-danger">{errors.password}</small>
                        )}

                        <span
                          className="position-absolute"
                          style={{
                            cursor: "pointer",
                            top: "28%",
                            right: "35px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              password: !showPassword.password,
                            })
                          }
                        >
                          <i
                            className={`bi ${showPassword.password ? "bi-eye-slash-fill" : "bi-eye-fill"
                              }`}
                            style={{ fontSize: "1.2rem", color: "#555" }}
                          ></i>
                        </span>

                        {/* Forgot Password Link */}
                        <a
                          href="#"
                          data-bs-target="#ForgotPasswordModalToggle"
                          data-bs-toggle="modal"
                          className="float-end mt-1"
                        >
                          <small>Forgot Password?</small>
                        </a>
                      </div>


                      <div className="col-md-12 mb-3">
                        <button
                          type="submit"
                          className="eagle-btn text-center w-100"
                          disabled={loading}
                        >
                          <span className="eagle-button-text">
                            {loading ? "Logging in..." : "Login"}
                          </span>
                          <span className="eagle-button-icon-wrapper">
                            <span className="eagle-button-icon">
                              <i className="eagle-base-icon-black-arrow-1"></i>
                            </span>
                          </span>
                        </button>
                      </div>

                      <div className="col-md-12 mb-3">
                        <button
                          type="button"
                          className="loginwith-google text-center eagle-btn w-100"
                          onClick={() => loginWithGoogle()}
                        >
                          <img
                            src="images/google.svg"
                            className="img-fluid"
                            alt="google"
                          />
                          <span className="eagle-button-text">Login with Google</span>
                        </button>
                      </div>

                      <div className="col-md-12 col-lg-12">
                        Don't have an account?{" "}
                        <a
                          href="javascript:void(0)"
                          data-bs-target="#signupModalToggle"
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                        >
                          Sign Up Now!
                        </a>
                      </div>


                    </div>
                  </form>
                </div>

                <div className="col-lg-6">
                  <img
                    src="images/banner-slider-img/1.jpg"
                    className="img-fluid"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End Login Model  */}
      <div
        className="modal fade commen-popup"
        id="OtpModalToggle"
        aria-hidden="true"
        aria-labelledby="OtpModalToggleLabel"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("OtpModalToggle")}
                  ></button>
                  {message && (
                    <div
                      className={`alert ${message.toLowerCase().includes("success")
                        ? "alert-success bg-success text-white"
                        : "alert-danger bg-danger text-white"
                        }`}
                      role="alert"
                    >
                      {message}
                    </div>
                  )}

                  <h5 className="mt-2">Enter OTP</h5>
                  <p>Please check your emails, including the spam folder, for the one time password we sent you.</p>

                  <form onSubmit={handleOTPSubmit}>
                    <div className="d-flex gap-2 mb-3">
                      {otp.map((digit, idx) => (
                        <input
                          key={idx}
                          type="text"
                          className="form-control text-center"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChangeOTP(e, idx)}
                          onKeyDown={(e) => handleBackspace(e, idx)}
                          ref={(el) => (inputsRef.current[idx] = el)}
                        />
                      ))}
                    </div>

                    <div className="col-md-12 gap-2 mb-3 d-flex">
                      <button
                        type="button"
                        className="eagle-btn text-center w-50"
                        onClick={handleBack}
                      >
                        BACK
                      </button>
                      <button
                        type="submit"
                        className="eagle-btn text-center w-50"
                        disabled={loading}
                      >
                        {loading ? "Verifying..." : "VERIFY"}
                      </button>
                    </div>
                    <div className="mb-2">
                      Didn't receive an OTP?{" "}
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={handleResendOTP}
                        disabled={loading}
                      >
                        {loading ? "Resending..." : "Resend"}
                      </button>
                    </div>

                  </form>
                </div>

                <div className="col-lg-6">
                  <img
                    src="images/banner-slider-img/1.jpg"
                    className="img-fluid"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      <div
        className="modal fade commen-popup"
        id="ForgotPasswordModalToggle"
        aria-hidden="true"
        aria-labelledby="ForgotPasswordModalToggleLabel"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: "list-item" }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("ForgotPasswordModalToggle")}
                  ></button>

                  <h5 className="modal-title" id="ForgotPasswordModalToggleLabel">
                    Forgot Password
                  </h5>
                  <p>
                    Enter your email id and we'll send you instructions to reset your password
                  </p>

                  <form
                    className="Login-form"
                    onSubmit={handleForgotPasswordSubmit}
                    noValidate
                  >
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email *"
                          name="forgotEmail"
                          value={forgotEmail}
                          onChange={(e) => setForgotEmail(e.target.value)}
                        />
                      </div>

                      <div className="col-md-12 mb-3 d-flex justify-content-between">
                        <button
                          type="button"
                          className="eagle-btn text-center w-50 me-2"
                          onClick={handleForgotBack}
                        >
                          BACK
                        </button>
                        <button
                          type="submit"
                          className="eagle-btn text-center w-50"
                          disabled={loadingForgot}
                        >
                          <span className="eagle-button-text">
                            {loadingForgot ? "Sending..." : "Send OTP"}
                          </span>
                          <span className="eagle-button-icon-wrapper">
                            <span className="eagle-button-icon">
                              <i className="eagle-base-icon-black-arrow-1"></i>
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="col-lg-6">
                  <img
                    src="images/banner-slider-img/1.jpg"
                    className="img-fluid"
                    alt="Forgot Password"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* RESET PASSWORD MODAL */}
      <div
        className="modal fade commen-popup"
        id="ResetPasswordModalToggle"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("ResetPasswordModalToggle")}
                  ></button>

                  <h5 className="modal-title">Reset Password</h5>
                  <p>Enter your new password below</p>

                  <form onSubmit={handleResetPassword}>
                    <div className="mb-2 position-relative">
                      <input
                        type={showPassword.password ? "text" : "password"}
                        className="form-control"
                        placeholder="New Password"
                        value={resetPassword.password}
                        onChange={(e) =>
                          setResetPassword({ ...resetPassword, password: e.target.value })
                        }
                      />
                      <span
                        className="position-absolute"
                        style={{
                          cursor: "pointer",
                          top: "50%",
                          right: "15px",
                          transform: "translateY(-50%)",
                        }}
                        onClick={() =>
                          setShowPassword({
                            ...showPassword,
                            password: !showPassword.password,
                          })
                        }
                      >
                        <i
                          className={`${showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                            }`}
                        ></i>
                      </span>
                      {resetErrors.password && (
                        <small className="text-danger">{resetErrors.password}</small>
                      )}
                    </div>

                    <div className="mb-2 position-relative">
                      <input
                        type={showPassword.confirmPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm Password"
                        value={resetPassword.confirmPassword}
                        onChange={(e) =>
                          setResetPassword({
                            ...resetPassword,
                            confirmPassword: e.target.value,
                          })
                        }
                      />
                      <span
                        className="position-absolute"
                        style={{
                          cursor: "pointer",
                          top: "50%",
                          right: "15px",
                          transform: "translateY(-50%)",
                        }}
                        onClick={() =>
                          setShowPassword({
                            ...showPassword,
                            confirmPassword: !showPassword.confirmPassword,
                          })
                        }
                      >
                        <i
                          className={`${showPassword.confirmPassword ? "bi bi-eye-slash" : "bi bi-eye"
                            }`}
                        ></i>
                      </span>
                      {resetErrors.confirmPassword && (
                        <small className="text-danger">{resetErrors.confirmPassword}</small>
                      )}
                    </div>

                    <button type="submit" className="eagle-btn w-100" disabled={loadingReset}>
                      {loadingReset ? "Resetting..." : "Reset Password"}
                    </button>
                  </form>


                </div>

                <div className="col-lg-6">
                  <img
                    src="images/banner-slider-img/1.jpg"
                    className="img-fluid"
                    alt="Reset Password"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Footer;
